<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from 'vuelidate/lib/validators'
import { signupEmailRule } from '../validation/rules'

Vue.use(Vuelidate)

export default {
    data() {
        return {
            inputEmail: ''
        }
    },
    validations: {
        inputEmail: {
            required,
            signupEmailRule
        }
    },
    computed: {
        email: function(){
            // 大文字を小文字に変換する
            return this.inputEmail.toLowerCase();
        },
        isDisabled: function(){
            return this.$v.$invalid;
        }
    },
    mounted: function(){
        if(typeof this.$refs.inputEmailField !== 'undefined'){
            // 再レンダリング時、前回入力した値をdata属性から取得する
            const previousInputEmail = this.$refs.inputEmailField.dataset.previousValue;
            if (typeof previousInputEmail !== 'undefined') this.inputEmail = previousInputEmail;
        }
    },
    methods: {
        submit: function(){
            const form = this.$refs.emailConfirmationForm;

            this.$v.$touch();
            if (this.$v.$invalid) {
                alert('バリデーションエラー');
                return false;
            } else {
                form.submit();
            }
        }
    }
}
</script>
